import { Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

export interface SwitchOption {
  label: string;
  value: string;
}

@Component({
  selector: 'dpqa-switch-group',
  standalone: true,
  imports: [CommonModule, TranslatePipe],
  templateUrl: './switch-group.component.html',
  styleUrl: './switch-group.component.less',
})
export class SwitchGroupComponent {
  /**
   * Array of options to display in the switch
   */
  options = input.required<SwitchOption[]>();

  /**
   * The current value of the switch (controlled by parent)
   */
  value = input.required<string>();

  /**
   * Is the switch disabled (non-interactive)
   */
  disabled = input(false);

  /**
   * Is the switch readonly (visual state but no interaction)
   */
  readonly = input(false);

  /**
   * Emitted when user selects a different option
   */
  onChange = output<string>();

  /**
   * Determine if an option is active
   */
  isActive(optionValue: string): boolean {
    return this.value() === optionValue;
  }

  /**
   * Handle option selection
   */
  selectOption(optionValue: string): void {
    if (this.disabled() || this.readonly()) { return; }

    if (this.value() !== optionValue) {
      this.onChange.emit(optionValue);
    }
  }
}
